import React from 'react';

import styles from '../../../../../common/ui/Tour/styles/Step.module.less';

const Step1Component = () => (
  <div className={styles.stepContainer}>
    <h3>Add Virtual Events to Your Schedule Page</h3>
    <p className={styles.stepCopy}>
      Guests will get all the details they need (like dress code!), and can attend each event with
      one click.
    </p>
  </div>
);

export default {
  target: '#public-wrapper',
  content: <Step1Component />,
  placement: 'left-start',
  disableBeacon: true,
  stepName: 'show_virtual_event_preview',
};
